import styled from 'styled-components'

import media from '../../../../services/generateMediaQueries'

export const EmbedRoot = styled.div`
  width: 100vw;
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${media.lessThan('small')`
    min-height: min(820px, calc(100vh - 9rem));
  `}
`

export const EmbedFrame = styled.iframe`
  flex: 1;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #fff;

  ${media.lessThan('small')`
    min-height: min(820px, calc(100vh - 9rem));
  `}
`
